import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-employer-name",
    prompt: (guidanceItem) => `Enter the employer Name, Tax ID, and other requested information. Select the correct legal entity type. Click Save.`, 
    briefDescription: 'Employer Name',
    openAction: {
        text: "Where to edit employer name?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Name",
    },
    completeAction: {
    }

});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-employer-name.js